import {
  normalizeSocialAccount,
  toLegacyFacebookFanpagePayload,
  toSelectedAccountPayload,
} from "./socialChannels";

export const PRODUCT_IMAGES_PLATFORM_FACEBOOK = "facebook";
export const PRODUCT_IMAGES_PLATFORM_ZALO = "zalo";
export const PRODUCT_IMAGES_PLATFORMS = [
  PRODUCT_IMAGES_PLATFORM_FACEBOOK,
  PRODUCT_IMAGES_PLATFORM_ZALO,
];

export const normalizeProductImagesPlatform = (platform) =>
  String(platform || "").toLowerCase() === PRODUCT_IMAGES_PLATFORM_ZALO
    ? PRODUCT_IMAGES_PLATFORM_ZALO
    : PRODUCT_IMAGES_PLATFORM_FACEBOOK;

export const getProductImageAccountLabel = (account = {}) =>
  normalizeProductImagesPlatform(account.platform) === PRODUCT_IMAGES_PLATFORM_ZALO
    ? "Zalo OA"
    : "Facebook";

export const getProductImageAccountSetupLabel = (platform) =>
  normalizeProductImagesPlatform(platform) === PRODUCT_IMAGES_PLATFORM_ZALO
    ? "Thiết lập Zalo OA để đăng bài"
    : "Thiết lập fanpage để đăng bài";

export const getProductImageAccountSelectLabel = (platform) =>
  normalizeProductImagesPlatform(platform) === PRODUCT_IMAGES_PLATFORM_ZALO
    ? "Chọn Zalo OA để đăng bài"
    : "Chọn Fanpage để đăng bài";

export const getProductImageAccountPlaceholder = (platform) =>
  normalizeProductImagesPlatform(platform) === PRODUCT_IMAGES_PLATFORM_ZALO
    ? "Chọn Zalo OA"
    : "Chọn Fanpages";

export const getProductImageSelectedAccounts = (product) => {
  if (!product) return [];
  if (Array.isArray(product.selectedAccounts) && product.selectedAccounts.length > 0) {
    return product.selectedAccounts.map((account) =>
      normalizeSocialAccount(account, account.platform || product.platform || "facebook")
    );
  }

  if (Array.isArray(product.fanpages) && product.fanpages.length > 0) {
    return product.fanpages.map((account) =>
      normalizeSocialAccount(account, "facebook")
    );
  }

  return [];
};

export const buildProductImagesSocialPayload = ({
  platform,
  selectedAccounts = [],
  postMode = "direct",
  includeContactInfo = false,
  useFanpageInfo = false,
  firstCommentEnabled = false,
  defaultFirstCommentText = "",
} = {}) => {
  const normalizedPlatform = normalizeProductImagesPlatform(platform);
  const samePlatformAccounts = selectedAccounts
    .map((account) => normalizeSocialAccount(account, normalizedPlatform))
    .filter(
      (account) =>
        account.accountId &&
        normalizeProductImagesPlatform(account.platform) === normalizedPlatform
    );
  const selectedAccountPayloads = samePlatformAccounts.map(toSelectedAccountPayload);
  const isFacebook = normalizedPlatform === PRODUCT_IMAGES_PLATFORM_FACEBOOK;
  const facebookFanpages = isFacebook
    ? samePlatformAccounts.map(toLegacyFacebookFanpagePayload)
    : [];
  const firstFanpage = facebookFanpages[0] || {};

  return {
    platform: normalizedPlatform,
    platformType: normalizedPlatform,
    selectedAccounts: selectedAccountPayloads,
    fanpages: facebookFanpages,
    accessToken: isFacebook ? firstFanpage.access_token || "" : "",
    fanpageID: isFacebook ? firstFanpage.id || "" : "",
    fanpageName: isFacebook ? firstFanpage.name || "" : "",
    imageURLs: "",
    postMode: isFacebook ? postMode : "direct",
    includeContactInfo: isFacebook ? includeContactInfo === true : false,
    useFanpageInfo: useFanpageInfo === true,
    firstCommentEnabled: isFacebook ? firstCommentEnabled === true : false,
    defaultFirstCommentText: isFacebook ? defaultFirstCommentText || "" : "",
  };
};
